import styles from './SearchDropdownEmpty.module.scss';

interface SearchDropdownEmptyProps {
  t: (key: string) => string;
}

export function SearchDropdownEmpty({ t }: SearchDropdownEmptyProps) {
  return (
    <div className={styles.noResults}>
      <span>{t('noResultsRound')}</span>
    </div>
  );
}
